import { render, staticRenderFns } from "./WechatCategoryAttributeDialog.vue?vue&type=template&id=34f69e62&scoped=true"
import script from "./WechatCategoryAttributeDialog.vue?vue&type=script&lang=js"
export * from "./WechatCategoryAttributeDialog.vue?vue&type=script&lang=js"
import style0 from "./WechatCategoryAttributeDialog.vue?vue&type=style&index=0&id=34f69e62&prod&scoped=true&lang=css"
import style1 from "./WechatCategoryAttributeDialog.vue?vue&type=style&index=1&id=34f69e62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f69e62",
  null
  
)

export default component.exports